import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h2 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h2>
            <p className="home-about-body">
              I am a passionate <b className="purple">AI & Data Science Developer</b> with a solid technical foundation in programming and problem-solving.
              <br />
              <br />
              I possess strong fluency in core languages, including
              <i>
                <b className="purple"> Python, Java, and C. </b>
              </i>
              <br />
              <br />
              My primary areas of interest include developing innovative &nbsp;
              <i>
                <b className="purple">Machine Learning & Deep Learning </b> solutions and conducting advanced{" "}
                <b className="purple">
                  Data Analytics.
                </b>
              </i>
              <br />
              <br />
              I actively apply my skills to build scalable web applications using <b className="purple">Python</b> and modern technologies such as
              <i>
                <b className="purple">
                  {" "}
                  Django, Flask, MongoDB, and Docker.
                </b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="Murugavel V - AI Developer Avatar" loading="lazy" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h2>FIND ME ON</h2>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Murugavl"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/murugavelv/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
